import { api } from '@/lib/api';
import type {
  AlertHistorySummaryResponse,
  AmDashboardFilters,
  AmDashboardResponse,
  AmHistorySummaryFilters,
  CallHistorySummaryResponse,
  EmailHistorySummaryResponse,
} from './types';

export interface AmDashboardAccountOption {
  id: string;
  name: string;
}

export async function fetchAmDashboard(
  filters: AmDashboardFilters,
): Promise<AmDashboardResponse> {
  return api.get<AmDashboardResponse>('/v4/am-dashboard', {
    sales_manager_id: filters.salesManagerId,
    search: filters.search,
    status: filters.status,
    tier: filters.tier,
    sort_by: filters.sortBy,
    sortDirection: filters.sortDirection,
    pageNumber: filters.pageNumber,
    pageLength: filters.pageLength,
    issue_filter: filters.issueFilter,
  });
}

export async function fetchAlertHistorySummary(
  filters: AmHistorySummaryFilters = {},
): Promise<AlertHistorySummaryResponse> {
  return api.get<AlertHistorySummaryResponse>('/v4/alert-histories/summary', {
    sales_manager_id: filters.salesManagerId,
    hours: filters.hours,
  });
}

export async function fetchEmailHistorySummary(
  filters: AmHistorySummaryFilters = {},
): Promise<EmailHistorySummaryResponse> {
  return api.get<EmailHistorySummaryResponse>('/v4/email-histories/summary', {
    sales_manager_id: filters.salesManagerId,
    hours: filters.hours,
  });
}

export async function fetchCallHistorySummary(
  filters: AmHistorySummaryFilters = {},
): Promise<CallHistorySummaryResponse> {
  return api.get<CallHistorySummaryResponse>('/v4/call-histories/summary', {
    sales_manager_id: filters.salesManagerId,
    hours: filters.hours,
  });
}

export async function fetchAmDashboardAccountNames(): Promise<AmDashboardAccountOption[]> {
  const PAGE_SIZE = 100;
  const allAccounts: AmDashboardAccountOption[] = [];
  let pageNumber = 0;

  // eslint-disable-next-line no-constant-condition
  while (true) {
    const response = await api.get<{
      accounts: AmDashboardAccountOption[];
      total: number;
    }>('/v4/accounts', {
      pageNumber,
      pageLength: PAGE_SIZE,
      sortKey: 'name',
      sortDirection: 1,
    });

    const accounts = response.accounts || [];
    allAccounts.push(...accounts);

    if (accounts.length < PAGE_SIZE) break;
    pageNumber += 1;
  }

  return allAccounts;
}
